(() => {
  if (typeof window.DHTimberEnquiry?.open === 'function') return;
  const dialog = document.querySelector('[data-dh-timber-enquiry]');
  const stringsNode = document.getElementById('DHTimberEnquiryStrings');
  if (!dialog || !stringsNode) return;
  let strings;
  try { strings = JSON.parse(stringsNode.textContent); } catch { return; }
  const form = dialog.querySelector('form');
  const selection = dialog.querySelector('[data-dh-enquiry-selection]');
  const requestField = dialog.querySelector('[data-dh-enquiry-request]');
  const regularFields = dialog.querySelector('[data-dh-enquiry-regular]');
  const fulfilment = dialog.querySelector('[data-dh-enquiry-fulfilment]');
  const addressField = dialog.querySelector('[data-dh-enquiry-address]');
  const eircode = dialog.querySelector('[data-dh-enquiry-eircode]');
  const sessionKey = 'dh-timber-enquiry-pending-v2';
  let previousFocus = null;
  let current = null;
  const integer = value => {
    const n = Math.floor(Number(value));
    return Number.isSafeInteger(n) && n > 0 ? n : 1;
  };
  const cents = value => {
    const n = Math.round(Number(value));
    return Number.isSafeInteger(n) && n > 0 ? n : 0;
  };
  const formatMoney = value => new Intl.NumberFormat(strings.locale || 'en-IE', {
    style: 'currency', currency: strings.currency || 'EUR'
  }).format(value / 100);
  const interpolate = (text, values) => Object.entries(values).reduce(
    (result, [key, value]) => result.replaceAll(`__${key}__`, String(value)), text || ''
  );
  const setRegular = regular => {
    regularFields.hidden = !regular;
    regularFields.querySelectorAll('input, select').forEach(field => { field.disabled = !regular; });
    document.getElementById('DHTimberEnquiryTitle').textContent = regular ? strings.regularTitle : strings.title;
    document.getElementById('DHTimberEnquiryIntro').textContent = regular ? strings.regularIntro : strings.intro;
    dialog.querySelector('[data-dh-enquiry-note]').textContent = regular ? strings.regularNote : strings.note;
    dialog.querySelector('[data-dh-enquiry-type]').value = regular ? strings.regularTitle : strings.title;
  };
  const updateDelivery = () => {
    const delivery = fulfilment.value === 'Delivery';
    addressField.hidden = !delivery;
    eircode.required = delivery;
    eircode.disabled = !delivery;
  };
  const normalise = detail => {
    const items = Array.isArray(detail?.items) ? detail.items : [];
    return {
      mode: detail?.mode === 'regular' ? 'regular' : 'order',
      items: items.filter(item => item && typeof item.title === 'string').map(item => ({
        productId: String(item.productId || ''),
        variantId: String(item.variantId || ''),
        title: item.title,
        url: typeof item.url === 'string' ? item.url : '',
        quantity: integer(item.quantity),
        unitPriceCents: cents(item.unitPriceCents)
      }))
    };
  };
  const renderSelection = detail => {
    const regular = detail.mode === 'regular';
    const body = [];
    let subtotal = 0;
    let allPriced = true;
    selection.replaceChildren();
    detail.items.forEach(item => {
      const entry = document.createElement('div');
      entry.className = 'dh-timber-enquiry__item';
      const title = document.createElement('strong');
      title.textContent = item.title;
      entry.append(title);
      const description = document.createElement('span');
      description.textContent = regular
        ? strings.regularLine
        : interpolate(strings.quantityLine, { count: item.quantity });
      entry.append(description);
      body.push(item.title, description.textContent);
      if (item.unitPriceCents > 0) {
        const price = document.createElement('span');
        price.className = 'dh-timber-enquiry__item-price';
        price.textContent = interpolate(strings.unitPriceLine, { price: formatMoney(item.unitPriceCents) });
        entry.append(price);
        body.push(price.textContent);
        if (!regular) {
          const lineTotal = document.createElement('span');
          lineTotal.textContent = interpolate(strings.lineTotal, { price: formatMoney(item.unitPriceCents * item.quantity) });
          entry.append(lineTotal);
          body.push(lineTotal.textContent);
          subtotal += item.unitPriceCents * item.quantity;
        }
      } else if (!regular) {
        allPriced = false;
      }
      if (item.url) body.push(item.url);
      body.push('');
      selection.append(entry);
    });
    if (!regular && detail.items.length > 1 && allPriced) {
      const total = document.createElement('p');
      total.className = 'dh-timber-enquiry__subtotal';
      total.textContent = interpolate(strings.requestTotal, { price: formatMoney(subtotal) });
      selection.append(total);
      body.push(total.textContent, '');
    }
    if (!regular) body.push(strings.orderDisclaimer);
    requestField.value = body.join('\n');
  };
  const open = (detail, restore = false) => {
    const next = normalise(detail);
    if (!next.items.length) return;
    current = next;
    setRegular(next.mode === 'regular');
    renderSelection(next);
    updateDelivery();
    if (!restore) {
      dialog.querySelector('[data-dh-enquiry-fields]').hidden = false;
      const success = dialog.querySelector('[data-dh-enquiry-success]');
      if (success) success.hidden = true;
      const errors = dialog.querySelector('[data-dh-enquiry-errors]');
      if (errors) errors.hidden = true;
    }
    if (!dialog.open) {
      previousFocus = document.activeElement;
      dialog.showModal();
      document.body.classList.add('dh-timber-enquiry-open');
    }
    document.getElementById('DHTimberEnquiryTitle').focus();
  };
  const fromProduct = panel => ({
    productId: panel.dataset.productId,
    variantId: panel.dataset.variantId,
    title: panel.dataset.title,
    url: panel.dataset.url,
    quantity: integer(panel.querySelector('[data-dh-order-count]')?.value),
    unitPriceCents: cents(panel.dataset.unitPriceCents)
  });
  const updatePanel = panel => {
    const input = panel.querySelector('[data-dh-order-count]');
    if (!input.checkValidity()) return;
    const item = fromProduct(panel);
    input.value = item.quantity;
    const total = panel.querySelector('[data-dh-order-total]');
    total.textContent = interpolate(strings.selectedLengths, { count: item.quantity });
    if (item.unitPriceCents > 0) {
      const price = document.createElement('strong');
      price.textContent = formatMoney(item.unitPriceCents * item.quantity);
      total.append(price);
    }
    panel.querySelector('[data-dh-order-step="-1"]').disabled = item.quantity <= 1;
  };
  document.addEventListener('dh:timber-enquiry', event => open(event.detail));
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-dh-order-enquire]');
    if (trigger) {
      const panel = trigger.closest('[data-dh-order-product]');
      if (!panel) return;
      event.preventDefault();
      if (!panel.querySelector('[data-dh-order-count]').reportValidity()) return;
      open({ mode: trigger.dataset.dhOrderEnquire, items: [fromProduct(panel)] });
      return;
    }
    const stepper = event.target.closest('[data-dh-order-step]');
    if (stepper) {
      const panel = stepper.closest('[data-dh-order-product]');
      if (!panel) return;
      const input = panel.querySelector('[data-dh-order-count]');
      input.value = Math.max(1, integer(input.value) + Number(stepper.dataset.dhOrderStep));
      updatePanel(panel);
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-dh-order-count]')) {
      if (!event.target.reportValidity()) return;
      updatePanel(event.target.closest('[data-dh-order-product]'));
    }
  });
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-dh-order-product]').forEach(updatePanel);
  });
  fulfilment.addEventListener('change', updateDelivery);
  dialog.querySelector('[data-dh-enquiry-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.classList.remove('dh-timber-enquiry-open');
    if (previousFocus?.isConnected) previousFocus.focus();
  });
  form.addEventListener('submit', event => {
    if (!current?.items.length) {
      event.preventDefault();
      return;
    }
    renderSelection(current);
    try { sessionStorage.setItem(sessionKey, JSON.stringify(current)); } catch {}
  });
  document.querySelectorAll('[data-dh-order-product]').forEach(updatePanel);
  updateDelivery();
  try {
    const pending = sessionStorage.getItem(sessionKey);
    const success = dialog.querySelector('[data-dh-enquiry-success]');
    const errors = dialog.querySelector('[data-dh-enquiry-errors]');
    if (pending && (success || errors)) {
      open(JSON.parse(pending), true);
      if (success) {
        dialog.querySelector('[data-dh-enquiry-fields]').hidden = true;
        success.focus();
        sessionStorage.removeItem(sessionKey);
      } else if (errors) {
        errors.focus();
      }
    }
  } catch {}
  window.DHTimberEnquiry = { open };
  window.DHTimberBales = window.DHTimberEnquiry;
})();
